import React, { useState } from 'react'
import * as R from 'ramda'

import { makeStyles } from '@material-ui/styles'
import { TextField } from '@material-ui/core'
import Autocomplete, {
  createFilterOptions,
} from '@material-ui/lab/Autocomplete'
import { useIntl } from 'react-intl'
import { htmlToPlainText } from 'libs/text'
import { DATE_FORMAT_VOUCHER } from 'libs/dateUtils'
import moment from 'moment'
import TextSecondaryNoUnderline from 'app/components/TextSecondaryNoUnderline'
import CreateVoucherDialog from 'app/main/dealsPromotions/CreateVoucherDialog'
import { useField } from 'formik'
import clsx from 'clsx'
import { getLocalizedDate } from 'commons/date'

const CREATE_VOUCHER_ID = 'create-voucher'

const useStyle = makeStyles((theme) => ({
  root: {
    '& .MuiAutocomplete-inputRoot': {
      overflowX: 'auto',
      height: 'auto',
      maxHeight: '130px',
      position: 'unset',
    },
    '& .MuiInputAdornment-positionEnd': {
      top: '50%',
      right: '2rem',
      position: 'absolute',
    },
    '& .MuiAutocomplete-hasPopupIcon': {
      paddingRight: '0 !important',
    },
    '& .MuiAutocomplete-endAdornment': {
      display: 'flex !important',
      position: 'unset',
    },
    '& .MuiInputBase-root': {
      paddingRight: '10px !important',
    },
  },
  noBorder: {
    '& .MuiOutlinedInput-notchedOutline': {
      border: 0,
    },
  },
}))

const AttachVoucherSelector = (props) => {
  const { name, label, options, onChange, fetchVouchers } = props
  const [field, meta, helpers] = useField({ name: 'voucher' })
  const value = field.value
  const isError = meta.error !== undefined && meta.error !== null

  const optionSelected =
    value !== null ? R.find(R.propEq('id', value), options) : null
  const classes = useStyle()
  const { formatMessage } = useIntl()

  const [isOpenOptions, setIsOpendOptions] = useState(false)
  const [isOpenCreate, setIsOpendCreate] = useState(false)

  const succes = async (model) => {
    await fetchVouchers({
      page: 1,
      limit: 999,
      status: 1,
      sort: 'name:ASC',
    })
    await helpers.setValue(model.id)
    await setIsOpendCreate(false)
  }

  const handleVoucherName = (option) => {
    const titleVoucher = R.compose(htmlToPlainText, R.prop('title'))(option)
    const message = formatMessage({
      id: 'createNotification.dialog.expiredDate',
    })

    const startDate = getLocalizedDate(option.startDate, 'DATE')
    const endDate = getLocalizedDate(option.endDate, 'DATE')
    return `${titleVoucher} (${message} ${[startDate, endDate].join(' - ')})`
  }

  const handleVoucherChange = (event, value) => {
    if (![null, undefined].includes(value) && value.id !== CREATE_VOUCHER_ID) {
      helpers.setValue(value.id)
      if (onChange) {
        onChange(value.id)
      }
    } else {
      helpers.setValue(null)
      if (onChange) {
        onChange(null)
      }
    }
  }

  const handleRenderOption = (option) => {
    return option.id === CREATE_VOUCHER_ID ? (
      <div className="py-3">
        {option.isEmpty ? (
          <div className="p-0 text-grey">
            {formatMessage({
              id: 'dealsPromotions.attach.select.empty',
            })}{' '}
          </div>
        ) : null}
        <div onClick={() => setIsOpendCreate(true)}>
          <TextSecondaryNoUnderline>{option.name}</TextSecondaryNoUnderline>
        </div>
      </div>
    ) : (
      handleVoucherName(option)
    )
  }

  const optionCreateVoucher = (option, params) => {
    const filter = createFilterOptions()
    const filtered = filter(option, params)

    return [
      {
        name: formatMessage({
          id: 'dealsPromotions.attach.select.button.create',
        }),
        id: CREATE_VOUCHER_ID,
        isEmpty: R.isEmpty(filtered),
      },
      ...filtered,
    ]
  }
  if (!R.find(R.propEq('id', value), options) && value) {
    return
  }

  return (
    <>
      <Autocomplete
        {...field}
        name={name}
        id={`${name}-id`}
        open={isOpenOptions}
        onOpen={() => setIsOpendOptions(true)}
        onClose={() => setIsOpendOptions(false)}
        autoHighlight
        options={options}
        value={optionSelected}
        getOptionLabel={handleRenderOption}
        renderOption={handleRenderOption}
        noOptionsText={
          <div varient="subtitle" className="text-gray-500">
            {formatMessage({
              id: 'dealsPromotions.attach.select.empty',
            })}
          </div>
        }
        getOptionSelected={(option, value) =>
          value ? option.id === value.id : false
        }
        renderInput={(params) => (
          <TextField {...params} placeholder={label} variant="outlined" />
        )}
        filterOptions={optionCreateVoucher}
        onChange={handleVoucherChange}
        className={clsx(
          classes.root,
          classes.noBorder,
          'bg-white rounded-8 border border-grey-input text-grey-100',
        )}
      />
      {isError && <div className="text-red text-13 my-4">{meta.error}</div>}
      <CreateVoucherDialog
        open={isOpenCreate}
        onCreateSuccess={succes}
        onClose={() => setIsOpendCreate(false)}
      />
    </>
  )
}

export default React.memo(AttachVoucherSelector)
